export default __webpack_public_path__ + "static/media/Spineduster.300028b5.jpg";